import React from "react";
import { Popover, ConfigProvider } from "antd";

import { Colors } from "../../config";

const ChatbotPopover = ({
  content,
  placement = "leftTop",
  title = null,
  trigger = "click",
  children,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgElevated: "white",
          colorText: "black",
          controlItemBgHover: Colors.LightSecondary,
          borderRadius: 24,
        },
      }}
    >
      <Popover
        placement={placement}
        title={title ?? null}
        content={content}
        arrow={{ pointAtCenter: true }}
        defaultOpen={true}
        trigger={trigger}
      >
        {children}
      </Popover>
    </ConfigProvider>
  );
};

export default ChatbotPopover;
